import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import ProcedureMoveAppBar from "../../../common/ProcedureMoveAppBar";
import Snackbar from "../../../common/Snackbar";
import { copyElement, moveSection } from "../../../redux/sectionSlice";
import { generateSHA256 } from "../../../util/generateSHA256";
import { parse } from "uuid";
import { getPages, renderPreview, renderVideo } from "../plugins/utils";
import RenderHtml from "../../../common/AppSpecificConpnents/PartsTable/RenderHtml";
import {
  calculateGroupHeight,
  calculateTextBlockWidth,
  estimateKonvaTextHeight,
  formatListContent,
  getTextStyle,
  hasNoteContent,
  hasTaskContent,
  hasUserContent,
  measureHtmlHeight,
  stripHtmlPreserveFormatting,
} from "../../SectionElements/plugins/utils.js";
import RectangleElement from "../../Canvas/components/rectangle/RectangleElement.jsx";
import ArrowElement from "../../Canvas/components/arrow/ArrowElement.jsx";
import CircleElement from "../../Canvas/components/circle/CircleElement.jsx";
import LineElement from "../../Canvas/components/line/LineElement.jsx";
import CanvasImage from "../../Canvas/components/canvas-core/CanvasImage.jsx";
import TextElement from "../../Canvas/components/text/TextElement.jsx";
import DoubleSidedArrowElement from "../../Canvas/components/arrow/DoubleSidedArrowElement.jsx";
import CanvasDisplay from "../../Canvas/components/canvas-core/CanvasDisplay.jsx";
import {
  generateSourceTreePath,
  generateTargetTreePath,
  getDisplayIndex,
  getSubstepLetter,
  generateStatusText,
  validateAndCorrectTreePathData,
  generateCompleteTreePath,
} from "../../SubassemblyDetails/utils/treePathUtils";
import { BASE } from "../../../config";
const ProcedureSectionCopyPreview = () => {
  const { sections } = useSelector((state) => state.section);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let richTextCounter = 1;
  let canvasCounter = 1;
  let videoCounter = 1;
  let formCounter = 1;
  let substepCounter = 1;
  let stepCounter = 1;
  const [isLoading, setIsLoading] = useState(false);
  const [isProcedureSelected, setIsProcedureSelected] = useState(false);
  const [sectionStatus, setSectionStatus] = useState("Pending");
  const [auditData, setAuditData] = useState({
    user_ref: localStorage.getItem("user_id") || "",
    ip_address: "",
    device_info: navigator.userAgent,
    hash: generateSHA256(Math.random().toString()),
    signature: "",
  }); // Fetch IP address and generate hash
  let richTextsCounter = {};
  let attachmentCounter = 1;
  const [isModalOpen, setModalOpen] = useState(false);
  const [comment, setComment] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    type: "",
  });
  const {
    stepsBySection,
    substepsByStep,
    richTexts,
    attachments,
    forms,
    canvases,
    videos,
  } = useSelector((state) => state.step);
  const [stepsBySectionPreview, setStepsBySectionPreview] = useState(
    stepsBySection || {}
  );

  const [selectedView, setSelectedView] = useState("new");

  const {
    moveType,
    sourceSectionIndex,
    targetSectionIndex,
    revision,
    partNumber,
    type,
    partId,
    revisionId,
    fromTreeId,
    fromSectionId,
    targetSectionData,
    fromSiblingOrder,
    section,
    steps,
    title,
    fromRevisionId,
    fromPartId,
    status,
    toType,
    description,
    toPartNumber,
    treeNode,
  } = location.state;

  const [previewSections, setPreviewSections] = useState([...sections]);

  // State variables to hold substeps and their child nodes for preview
  const [allSubsteps, setAllSubsteps] = useState(substepsByStep || {}); // Stores substeps keyed by stepId
  const [allRichTextsForSubsteps, setAllRichTextsForSubsteps] = useState({}); // Stores richTexts keyed by substepId
  const [allAttachmentsForSubsteps, setAllAttachmentsForSubsteps] = useState(
    {}
  ); // Stores attachments keyed by substepId
  const [allCanvasesForSubsteps, setAllCanvasesForSubsteps] = useState({}); // Stores canvases keyed by substepId
  const [allFormsForSubsteps, setAllFormsForSubsteps] = useState({}); // Stores forms keyed by substepId
  const [allVideosForSubsteps, setAllVideosForSubsteps] = useState({}); // Stores videos keyed by substepId
  const { substepsByStep: originalSubsteps } = useSelector(
    (state) => state.step
  );

  useEffect(() => {
    const {
      richTextsByStep,
      attachmentsByStep,
      canvasesByStep,
      formsByStep,
      videosByStep,
      richTexts,
      attachments,
      forms,
      videos,
      canvases,
      substepsByStep,
    } = location.state;

    setAllRichTextsForSubsteps((prev) => ({ ...prev, ...richTexts }));
    setAllAttachmentsForSubsteps((prev) => ({ ...prev, ...attachments }));
    setAllCanvasesForSubsteps((prev) => ({ ...prev, ...canvases }));
    setAllFormsForSubsteps((prev) => ({ ...prev, ...forms }));
    setAllVideosForSubsteps((prev) => ({ ...prev, ...videos }));

    const newSections = [...sections];
    // const targetIndex = targetSectionIndex; // This variable is not used after definition, can be removed.

    const originalSteps = [
      ...(stepsBySectionPreview[section.section_tree_node_id] || []),
    ];

    if (selectedView === "original") {
      // Show original unmodified data
      setStepsBySectionPreview((prev) => ({
        ...prev,
        [section.section_tree_node_id]: originalSteps,
      }));
      setPreviewSections(newSections);
      setAllSubsteps(originalSubsteps);
    } else {
      // --- Clone section ---
      const newSectionId = `${section.section_tree_node_id}`; // Consider generating a truly unique ID if this is a copy operation and not just a reorder preview.
      const targetSiblingOrder = parseInt(targetSectionData?.siblingOrder);

      const clonedSection = {
        ...structuredClone(section),
        section_tree_node_id: newSectionId,
        section_name: `${section.section_name}`, // Not sure why you're templating an existing string, but it doesn't hurt.
        sibling_order: targetSiblingOrder, // We'll set the correct order after insertion
      };

      // --- Clone steps & content ---
      const clonedSteps = steps.map((step) => {
        const stepId = step.step_tree_node_id;
        const newStepId = `${stepId}`; // Again, consider truly unique IDs if copying.

        return {
          ...structuredClone(step),
          step_tree_node_id: newStepId,
          richTexts: (richTextsByStep[stepId] || []).map((r) => ({
            ...structuredClone(r),
            rich_text_tree_node_id: `${r.rich_text_tree_node_id}`,
          })),
          attachments: (attachmentsByStep[stepId] || []).map((a) => ({
            ...structuredClone(a),
            attachment_tree_node_id: `${a.attachment_tree_node_id}`,
          })),
          canvases: (canvasesByStep[stepId] || []).map((c) => ({
            ...structuredClone(c),
            canvas_tree_node_id: `${c.canvas_tree_node_id}`,
          })),
          forms: (formsByStep[stepId] || []).map((f) => ({
            ...structuredClone(f),
            form_tree_node_id: `${f.form_tree_node_id}`,
          })),
          videos: (videosByStep[stepId] || []).map((v) => ({
            ...structuredClone(v),
            video_tree_node_id: `${v.video_tree_node_id}`,
          })),
        };
      });

      // --- Update preview maps ---
      setStepsBySectionPreview((prev) => ({
        ...prev,
        [newSectionId]: clonedSteps,
      }));

      // Insert the cloned section at the correct position based on array index
      const updatedSections = [...newSections];

      // Find the target section index in the array
      const targetSectionIndex = updatedSections.findIndex(
        (s) => s.section_tree_node_id === targetSectionData?.sectionId
      );

      let insertIndex;

      // Special handling for "Paste Into" procedure (when no sectionId is provided)
      if (!targetSectionData?.sectionId && moveType === "below") {
        // Paste Into: Insert at the end of the procedure
        insertIndex = updatedSections.length;
      } else if (moveType === "up") {
        // Insert before the target section
        insertIndex = targetSectionIndex;
      } else {
        // Insert after the target section
        insertIndex = targetSectionIndex + 1;
      }

      // Insert the cloned section at the calculated index
      updatedSections.splice(insertIndex, 0, clonedSection);

      // Now reassign sibling orders based on the new array positions
      const finalSections = updatedSections.map((section, index) => ({
        ...section,
        sibling_order: index + 1, // Start from 1
      }));

      setPreviewSections(finalSections);

      setAllSubsteps((prev) => ({
        ...prev,
        ...substepsByStep,
      }));
    }
  }, [selectedView, location.state, sections]); // Added dependencies for useEffect

  const showSnackbar = (message, type) => {
    setSnackbar({ open: true, message, type });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleConfirm = () => {
    setModalOpen(true);
  };

  const compareSiblingOrders = (a, b) => {
    const intA = parseInt(a, 10);
    const intB = parseInt(b, 10);
    return intA - intB;
  };
  useEffect(() => {
    fetch("https://api.ipify.org?format=json")
      .then((res) => res.json())
      .then((data) =>
        setAuditData((prev) => ({ ...prev, ip_address: data.ip }))
      )
      .catch((err) => console.error("Failed to fetch IP:", err));
  }, []);

  const handleConfirmSave = async () => {
    if (!comment) {
      showSnackbar("Comment is mandatory.", "error");
      return;
    }

    setIsLoading(true); // Show the page loader

    const hash = await generateSHA256(Math.random().toString());

    const payload = {
      from_procedure_tree_node_ref: fromTreeId,
      from_order: parseInt(fromSiblingOrder),
      from_type: "section",
      from_part_id_ref: fromPartId,
      from_procedure_rev_ref: fromRevisionId,
      from_section_id_ref: fromSectionId,
      from_step_id_ref: "",
      from_substep_id_ref: "",
      to_procedure_tree_node_ref: targetSectionData?.sectionTreeId,
      to_order:
        moveType === "up"
          ? parseInt(targetSectionData?.siblingOrder)
          : parseInt(targetSectionData?.siblingOrder) + 1,
      to_type: "section",
      to_part_id_ref: partId,
      to_procedure_rev_ref: revisionId,
      to_section_id_ref: targetSectionData?.sectionId,
      to_step_id_ref: "",
      to_substep_id_ref: "",
      direction: moveType === "up" ? "paste_up" : "paste_down",
      audit_trail_data: {
        ...auditData,
        hash,
        action: moveType === "up" ? "paste_up" : "paste_down",
        comment: `Copied ${title} to Section ${
          targetSectionIndex + 1
        } in ${type} ${partNumber} ${revision}`,
        date: new Date().toISOString(),
        parent_version: null,
        version_content: {
          rule_name: "Field Changes Tracking",
          modified_fields: {},
        },
      },
    };

    try {
      await dispatch(copyElement(payload)).unwrap();
      setModalOpen(false);
      navigate(
        `/revision-submission/${partId}/${revision}/${toType}/${toPartNumber}/${revisionId}/${description}`,
        { state: { status } }
      );
    } catch (error) {
      console.error("Error copying section:", error);
      showSnackbar("Error copying section: " + error?.message, "error");
    } finally {
      setIsLoading(false); // Hide the page loader
    }
  };
  const getReorderedSections = (
    sections,
    sourceIndex,
    targetIndex,
    moveType
  ) => {
    // Create a copy of sections to work with
    let reorderedSections = [...sections];

    // Sort sections by sibling order
    reorderedSections.sort((a, b) => {
      const orderA = parseInt(
        a.sibling_order || a.procedure_tree?.sibling_order || "0",
        10
      );
      const orderB = parseInt(
        b.sibling_order || b.procedure_tree?.sibling_order || "0",
        10
      );
      return orderA - orderB;
    });

    // Return the sorted sections
    return reorderedSections;
  };

  const reorderedPreviewSections = getReorderedSections(
    previewSections,
    sourceSectionIndex,
    targetSectionIndex,
    moveType
  );

  const handleProcedureCheckboxChange = () => {
    setIsProcedureSelected(!isProcedureSelected);
  };

  return (
    <div style={{ position: "relative" }}>
      {/* Main Page Loader */}
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999,
          }}
        >
          <div
            style={{
              backgroundColor: "white",
              padding: "20px",
              borderRadius: "8px",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div
              style={{
                border: "4px solid #f3f3f3",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                animation: "spin 1s linear infinite",
                marginBottom: "10px",
              }}
            ></div>
            <div style={{ fontSize: "16px", color: "#333" }}>
              Copying Section...
            </div>
          </div>
        </div>
      )}

      <ProcedureMoveAppBar
        showBackButton={false}
        showCancelButton={true}
        selectedView={selectedView}
        setSelectedView={setSelectedView}
        title="Please Confirm the Changes"
        buttons={[{ label: "Confirm", onClick: handleConfirm }]}
        // subheadingBelowTitle={location.state.copyTitle || ""}
      />
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          padding: "8px 20px",
          flexWrap: "wrap", // for responsiveness
        }}
      >
        {/* Checkbox + Title + Description */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <label
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              cursor: "pointer",
              margin: 0,
            }}
          >
            <span style={{ fontSize: "19px", fontWeight: 600 }}>
              {toType} {toPartNumber}
            </span>
            {isProcedureSelected && (
              <span
                style={{
                  marginLeft: "12px",
                  fontSize: "14px",
                  color: "#666",
                  fontStyle: "italic",
                }}
              >
                {/* (Copy to end) */}
              </span>
            )}
          </label>
        </div>

        {/* Right-aligned section */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "20px",
            marginLeft: "auto",
          }}
        >
          <div>
            <strong>Status: </strong>
            <span style={{ color: "orange" }}>
              {location.state.status || status}
            </span>
          </div>

          <div>
            <strong>Revision: </strong>
            <span>{revision}</span>
          </div>
        </div>
      </div>
      <div className="header-spacing" style={{ padding: "20px" }}>
        <div style={{ marginTop: "20px" }}>
          {reorderedPreviewSections
            .sort((a, b) => {
              const orderA = a.sibling_order || a.procedure_tree?.sibling_order;
              const orderB = b.sibling_order || b.procedure_tree?.sibling_order;

              const orderCompare = compareSiblingOrders(orderA, orderB);
              if (orderCompare !== 0) return orderCompare;

              // Fallback: compare created_at
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA; // latest comes first
            })
            .map((section, index) => {
              const stepsToRender =
                stepsBySectionPreview[section.section_tree_node_id] || [];
              return (
                <div
                  className="header-spacing"
                  key={section.section_tree_node_id}
                  style={{
                    margin: "20px 0",
                  }}
                >
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      cursor: "pointer",
                    }}
                  >
                    <h2 style={{ margin: 0, fontSize: "20px" }}>
                      Section {index + 1}
                    </h2>
                  </label>
                  <hr />
                  <hr />
                  <div>{section.section_name}</div>
                  <div>{section.short_description}</div>

                  {/* Steps for this section */}
                  {(stepsToRender || []).map((step, stepIndex) => {
                    const stepId = step.step_tree_node_id;
                    const sectionId = section.section_tree_node_id;
                    stepCounter++;
                    const stepsBeforeThisSection = reorderedPreviewSections
                      .slice(0, index)
                      .reduce(
                        (acc, s) =>
                          acc +
                          (stepsBySectionPreview[s.section_tree_node_id]
                            ?.length || 0),
                        0
                      );
                    const globalStepNumber =
                      stepsBeforeThisSection + stepIndex + 1;

                    const substeps = allSubsteps[stepId] || [];

                    const substepLetter = String.fromCharCode(
                      65 + substeps.length
                    ); // A, B, C...

                    // Calculate media counters before navigation
                    const currentAttachmentCounter = attachmentCounter;
                    const currentVideoCounter = videoCounter;
                    const currentFormCounter = formCounter;
                    const currentCanvasCounter = canvasCounter;
                    const currentRichTextCounter = richTextCounter;

                    // Update counters for next step
                    //attachmentCounter += myAttachments.length;
                    // videoCounter += myVideos.length;
                    // formCounter += myForms.length;
                    // canvasCounter += myCanvases.length;
                    // richTextCounter += myRichTexts.length; // If you're adding one richText per step

                    richTextsCounter[stepId] = currentRichTextCounter;
                    const combinedItems = [
                      ...(richTexts[stepId] || []).map((item) => ({
                        ...item,
                        type: "richText",
                      })),
                      ...(forms[stepId] || []).map((item) => ({
                        ...item,
                        type: "form",
                      })),
                      ...(attachments[stepId] || []).map((item) => ({
                        ...item,
                        type: "attachment",
                      })),
                      ...(canvases[stepId] || []).map((item) => ({
                        ...item,
                        type: "canvas",
                      })),
                      ...(videos[stepId] || []).map((item) => ({
                        ...item,
                        type: "video",
                      })),
                      ...(step.attachments || []).map((item) => ({
                        ...item,
                        type: "attachment",
                      })),
                      ...(step.videos || []).map((item) => ({
                        ...item,
                        type: "video",
                      })),
                      ...(step.forms || []).map((item) => ({
                        ...item,
                        type: "form",
                      })),
                      ...(step.canvases || []).map((item) => ({
                        ...item,
                        type: "canvas",
                      })),
                      ...(step.richTexts || []).map((item) => ({
                        ...item,
                        type: "richText",
                      })),
                    ]; // Filter out substeps or unwanted items (same as your current filter)
                    const filteredItems = combinedItems.filter(
                      (item) =>
                        !item.substep_id_ref && !item.sub_step_tree_node_id
                    );

                    filteredItems.sort((a, b) => {
                      const orderA =
                        a.sibling_order || a.procedure_tree?.sibling_order;
                      const orderB =
                        b.sibling_order || b.procedure_tree?.sibling_order;

                      const orderCompare = compareSiblingOrders(orderA, orderB);
                      if (orderCompare !== 0) return orderCompare;

                      // Fallback: compare created_at
                      const dateA = new Date(a.created_at);
                      const dateB = new Date(b.created_at);
                      return dateB - dateA; // latest comes first
                    });

                    return (
                      <div
                        className="header-spacing"
                        key={stepId}
                        style={{ marginTop: "20px" }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <label
                            style={{
                              display: "flex",
                              gap: "8px",
                              cursor: "pointer",
                            }}
                          >
                            <h2
                              style={{
                                margin: 0,
                                color: "#333",
                                fontSize: "20px",
                              }}
                            >
                              Step {globalStepNumber}
                            </h2>
                          </label>

                          <div
                            style={{
                              color: "#888",
                              fontSize: "14px",
                              fontWeight: "normal",
                            }}
                          >
                            Section{" "}
                            {reorderedPreviewSections.findIndex(
                              (s) =>
                                s.section_tree_node_id ===
                                section.section_tree_node_id
                            ) + 1}{" "}
                            &gt; Step {globalStepNumber}
                          </div>
                        </div>
                        <hr />
                        <p style={{ whiteSpace: 'pre-wrap' }}>{step.short_description || ""}</p>
                        <p>
                          <p>
                            {structuredClone(step.step_details)
                              .sort(
                                (a, b) =>
                                  new Date(a.created_at) -
                                  new Date(b.created_at)
                              )
                              .map((myStep, index) => {
                                const partNumber =
                                  myStep.part_info?.part_number || "";
                                const description =
                                  myStep.part_info?.description || "";
                                const qtyText =
                                  myStep.qty && myStep.qty !== 0
                                    ? `Qty ${myStep.qty}`
                                    : "";

                                const partText = partNumber
                                  ? ` (${partNumber})`
                                  : "";

                                return (
                                  <span key={index}>
                                    {myStep.action}
                                    {partText}{" "}
                                    <RenderHtml content={description} />{" "}
                                    {qtyText}
                                    &nbsp;
                                  </span>
                                );
                              })}
                          </p>
                        </p>

                        <h4>
                          {step.bom_table_title_info?.category_name || ""}
                        </h4>

                        <table className="table">
                          <thead>
                            <tr>
                              <th>Type</th>
                              <th>
                                {
                                  step.part_number_column_title_ref_info
                                    ?.category_name
                                }{" "}
                              </th>
                              <th>Description</th>
                              <th>Qty Per</th>
                              <th>Unit</th>
                            </tr>
                          </thead>

                          <tbody>
                            {step.parts_required.map((row) => (
                              <tr>
                                <td>{row.part_info.type_info.name}</td>
                                <td>{row.part_info.part_number}</td>
                                <td>
                                  <RenderHtml
                                    content={row.part_info.description}
                                  />
                                </td>
                                <td>{row.qty === 0 ? "" : row.qty}</td>
                                <td>{row.part_info?.unit_info?.unit_name}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>

                        {/* Step Content */}

                        {filteredItems.map((item, index) => {
                          if (item.substep_id_ref || item.sub_step_tree_node_id)
                            return null;
                          switch (item.type) {
                            case "richText": {
                              const globalRichTextNumber = richTextCounter++; // ✅ use then increment
                              // render richText block here
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Rich Text {globalRichTextNumber}
                                </h2>
                              );

                              return (
                                <div
                                  className="header-spacing"
                                  key={item.rich_text_tree_node_id}
                                  style={{ marginTop: "20px" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section{" "}
                                      {reorderedPreviewSections.findIndex(
                                        (s) =>
                                          s.section_tree_node_id ===
                                          section.section_tree_node_id
                                      ) + 1}{" "}
                                      &gt; Step {globalStepNumber}
                                    </div>
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: "5px",
                                      marginTop: "-10px",
                                    }}
                                  >
                                    {item.short_description}
                                  </div>
                                  <div
                                    style={{
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    {item.category_data?.category_name}
                                  </div>
                                  <div
                                    style={{
                                      fontSize: "14px",
                                      marginLeft: "4px",
                                      marginTop: "5px",
                                    }}
                                  >
                                    <div
                                      style={{ marginTop: "-6px" }}
                                      dangerouslySetInnerHTML={{
                                        __html: item.rich_text_content,
                                      }}
                                    />
                                  </div>
                                </div>
                              );
                            }
                            case "video": {
                              const globalVideoNumber = videoCounter++; // ✅ use then increment
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Video {globalVideoNumber}
                                </h2>
                              );

                              return (
                                <div
                                  className="header-spacing"
                                  key={label}
                                  style={{ marginTop: "20px" }}
                                >
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section{" "}
                                      {reorderedPreviewSections.findIndex(
                                        (s) =>
                                          s.section_tree_node_id ===
                                          section.section_tree_node_id
                                      ) + 1}{" "}
                                      &gt; Step {globalStepNumber}
                                    </div>
                                  </div>

                                  <video
                                    src={`${
                                      item.video.includes("http")
                                        ? item.video
                                        : `${BASE}${item.video}`
                                    }`}
                                    controls
                                    style={{
                                      width: "100%",
                                      maxHeight: "360px",
                                      borderRadius: "6px",
                                      backgroundColor: "#000",
                                    }}
                                  />
                                  <div>{item.video_url}</div>

                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }

                            case "form": {
                              const globalFormNumber = formCounter++; // ✅ use then increment
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Form {globalFormNumber}
                                </h2>
                              );
                              // render form block here
                              return (
                                <div key={label}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        marginTop: "20px",
                                      }}
                                    >
                                      {label}
                                    </label>
                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section{" "}
                                      {reorderedPreviewSections.findIndex(
                                        (s) =>
                                          s.section_tree_node_id ===
                                          section.section_tree_node_id
                                      ) + 1}{" "}
                                      &gt; Step {globalStepNumber}
                                    </div>
                                  </div>
                                  <div>{item.short_description}</div>
                                </div>
                              );
                            }
                            case "canvas": {
                              const pages = getPages(item);

                              const globalCanvasNumber = canvasCounter++; // ✅ use then increment
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Canvas {globalCanvasNumber}
                                </h2>
                              );
                              const shapes = item.shapes || [];

                              return (
                                <div key={label} style={{ marginTop: "40px" }}>
                                  <div
                                    className="header-spacing"
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                      }}
                                    >
                                      <h2>{label}</h2>
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section{" "}
                                      {reorderedPreviewSections.findIndex(
                                        (s) =>
                                          s.section_tree_node_id ===
                                          section.section_tree_node_id
                                      ) + 1}{" "}
                                      &gt; Step {globalStepNumber}
                                    </div>
                                  </div>

                                  <div>{item.short_description}</div>

                                  {/* Display all pages vertically */}
                                  <CanvasDisplay pages={pages} />
                                </div>
                              );
                            }
                            case "attachment": {
                              const attachmentList = item.attachments || [];
                              if (attachmentList.length === 0) return null;

                              //  const globalAttachmentNumber =
                              //           attachmentCounter++; // ✅ use then increment
                              const globalAttachmentNumber =
                                attachmentCounter++; // ✅ Increment here per attachment
                              const label = (
                                <h2 style={{ color: "#333", fontSize: "20px" }}>
                                  Attachment {globalAttachmentNumber}
                                </h2>
                              );

                              return (
                                <div className="header-spacing" key={item}>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        gap: "6px",
                                        cursor: "pointer",
                                        marginTop: "20px",
                                      }}
                                    >
                                      {label}
                                    </label>

                                    <div
                                      style={{
                                        color: "#888",
                                        fontSize: "14px",
                                        fontWeight: "normal",
                                      }}
                                    >
                                      Section{" "}
                                      {reorderedPreviewSections.findIndex(
                                        (s) =>
                                          s.section_tree_node_id ===
                                          section.section_tree_node_id
                                      ) + 1}{" "}
                                      &gt; Step {globalStepNumber}
                                    </div>
                                  </div>
                                  <div>{item.short_description}</div>
                                  {attachmentList.map((attachment, i) => (
                                    <div key={i} style={{ marginLeft: "20px" }}>
                                      {renderPreview(attachment)}
                                    </div>
                                  ))}
                                </div>
                              );
                            }
                            default:
                              return null;
                          }
                        })}

                        {/* Substeps */}
                        {(allSubsteps[stepId] || []).map(
                          (substep, substepIndex) => {
                            const substepId = substep.sub_step_tree_node_id;
                            const combinedItems = [
                              ...(richTexts[substepId] || []).map((item) => ({
                                ...item,
                                type: "richText",
                              })),
                              ...(forms[substepId] || []).map((item) => ({
                                ...item,
                                type: "form",
                              })),
                              ...(attachments[substepId] || []).map((item) => ({
                                ...item,
                                type: "attachment",
                              })),
                              ...(canvases[substepId] || []).map((item) => ({
                                ...item,
                                type: "canvas",
                              })),
                              ...(videos[substepId] || []).map((item) => ({
                                ...item,
                                type: "video",
                              })),
                            ]; // Filter out substeps or unwanted items (same as your current filter)
                            const filteredItems = combinedItems;

                            filteredItems.sort((a, b) => {
                              const orderA =
                                a.sibling_order ||
                                a.procedure_tree?.sibling_order;
                              const orderB =
                                b.sibling_order ||
                                b.procedure_tree?.sibling_order;

                              const orderCompare = compareSiblingOrders(
                                orderA,
                                orderB
                              );
                              if (orderCompare !== 0) return orderCompare;

                              // Fallback: compare created_at
                              const dateA = new Date(a.created_at);
                              const dateB = new Date(b.created_at);
                              return dateB - dateA; // latest comes first
                            });

                            // Global step number (same logic you already use for steps)
                            const stepsBeforeThisOne =
                              reorderedPreviewSections
                                .slice(0, index)
                                .reduce((sectionAcc, s) => {
                                  const steps =
                                    stepsBySectionPreview[
                                      s.section_tree_node_id
                                    ] || [];
                                  return sectionAcc + steps.length;
                                }, 0) + stepIndex;

                            const globalStepNumber = stepsBeforeThisOne + 1;

                            // Final substep label like Substep 5A
                            const substepLetter = String.fromCharCode(
                              65 + substepIndex
                            ); // A, B, C, ...

                            const globalSubstepLabel = `Substep ${globalStepNumber}${substepLetter}`;

                            return (
                              <div
                                className="header-spacing"
                                key={substepId}
                                style={{ marginTop: "20px" }}
                              >
                                <div>
                                  <div
                                    style={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                      alignItems: "center",
                                    }}
                                  >
                                    <label
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        width: "100%",
                                      }}
                                    >
                                      <h2
                                        style={{
                                          margin: 0,
                                          color: "#333",
                                          fontSize: "20px",
                                        }}
                                      >
                                        {globalSubstepLabel}
                                      </h2>
                                      <div
                                        style={{
                                          color: "#888",
                                          fontSize: "14px",
                                          fontWeight: "normal",
                                        }}
                                      >
                                        Section{" "}
                                        {reorderedPreviewSections.findIndex(
                                          (s) =>
                                            s.section_tree_node_id ===
                                            section.section_tree_node_id
                                        ) + 1}{" "}
                                        &gt; Step {globalStepNumber} &gt;
                                        Substep {globalStepNumber}
                                        {substepLetter}
                                      </div>
                                    </label>
                                  </div>

                                  <div style={{ whiteSpace: 'pre-wrap' }}>{substep.short_description}</div>
                                </div>

                                {/* Substep Rich Texts */}
                                {filteredItems.map((item, itemIndex) => {
                                  // Determine if this is the source item being moved (within substep)

                                  switch (item.type) {
                                    case "richText": {
                                      const currentRichTextNumber =
                                        richTextCounter++;
                                      const richTextId =
                                        item.rich_text_node_id ||
                                        `rich-text-${currentRichTextNumber}`;
                                      const label = (
                                        <h2
                                          style={{
                                            color: "#333",
                                            fontSize: "20px",
                                          }}
                                        >
                                          Rich Text {currentRichTextNumber}
                                        </h2>
                                      );

                                      return (
                                        <div
                                          className="header-spacing"
                                          key={richTextId}
                                          style={{ marginTop: "20px" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section{" "}
                                              {reorderedPreviewSections.findIndex(
                                                (s) =>
                                                  s.section_tree_node_id ===
                                                  section.section_tree_node_id
                                              ) + 1}{" "}
                                              &gt; Step {globalStepNumber} &gt;
                                              Substep {globalStepNumber}
                                              {substepLetter}
                                            </div>
                                          </div>

                                          <div
                                            style={{
                                              marginLeft: "5px",
                                              marginTop: "-10px",
                                            }}
                                          >
                                            {item.short_description}
                                          </div>
                                          <div
                                            style={{
                                              marginLeft: "4px",
                                              marginTop: "5px",
                                            }}
                                          >
                                            {item.category_data?.category_name}
                                          </div>
                                          <div
                                            style={{
                                              fontSize: "14px",
                                              marginLeft: "4px",
                                              marginTop: "5px",
                                            }}
                                          >
                                            <div
                                              style={{ marginTop: "-6px" }}
                                              dangerouslySetInnerHTML={{
                                                __html: item.rich_text_content,
                                              }}
                                            />
                                          </div>
                                        </div>
                                      );
                                    }
                                    case "video": {
                                      const currentVideoNumber = videoCounter++;
                                      const label = (
                                        <h2
                                          style={{
                                            color: "#333",
                                            fontSize: "20px",
                                          }}
                                        >
                                          Video {currentVideoNumber}
                                        </h2>
                                      );

                                      return (
                                        <div
                                          className="header-spacing"
                                          key={
                                            item.video_tree_node_id ||
                                            `video-${currentVideoNumber}`
                                          }
                                          style={{ marginTop: "20px" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section{" "}
                                              {reorderedPreviewSections.findIndex(
                                                (s) =>
                                                  s.section_tree_node_id ===
                                                  section.section_tree_node_id
                                              ) + 1}{" "}
                                              &gt; Step {globalStepNumber} &gt;
                                              Substep {globalStepNumber}
                                              {substepLetter}
                                            </div>
                                          </div>

                                          {renderVideo(item)}

                                          <div>{item.video_url}</div>

                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }

                                    case "form": {
                                      const currentFormNumber = formCounter++;
                                      const label = (
                                        <h2
                                          style={{
                                            color: "#333",
                                            fontSize: "20px",
                                          }}
                                        >
                                          Form {currentFormNumber}
                                        </h2>
                                      );

                                      return (
                                        <div
                                          className="header-spacing"
                                          key={
                                            item.form_tree_node_id ||
                                            `form-${currentFormNumber}`
                                          }
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                marginTop: "20px",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section{" "}
                                              {reorderedPreviewSections.findIndex(
                                                (s) =>
                                                  s.section_tree_node_id ===
                                                  section.section_tree_node_id
                                              ) + 1}{" "}
                                              &gt; Step {globalStepNumber} &gt;
                                              Substep {globalStepNumber}
                                              {substepLetter}
                                            </div>
                                          </div>
                                          <div>{item.short_description}</div>
                                        </div>
                                      );
                                    }
                                    case "canvas": {
                                      const pages = getPages(item);

                                      const currentCanvasNumber =
                                        canvasCounter++;
                                      const label = (
                                        <h2
                                          style={{
                                            color: "#333",
                                            fontSize: "20px",
                                          }}
                                        >
                                          Canvas {currentCanvasNumber}
                                        </h2>
                                      );

                                      return (
                                        <div
                                          className="header-spacing"
                                          key={
                                            item.canvas_tree_node_id ||
                                            `canvas-${currentCanvasNumber}`
                                          }
                                          style={{ marginTop: "40px" }}
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                              }}
                                            >
                                              <h2>{label}</h2>
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section{" "}
                                              {reorderedPreviewSections.findIndex(
                                                (s) =>
                                                  s.section_tree_node_id ===
                                                  section.section_tree_node_id
                                              ) + 1}{" "}
                                              &gt; Step {globalStepNumber} &gt;
                                              Substep {globalStepNumber}
                                              {substepLetter}
                                            </div>
                                          </div>

                                          {/* Display all pages vertically */}
                                          <CanvasDisplay
                                            pages={pages}
                                            hasUserContent={hasUserContent}
                                            getTextStyle={getTextStyle}
                                            stripHtmlPreserveFormatting={
                                              stripHtmlPreserveFormatting
                                            }
                                            estimateKonvaTextHeight={
                                              estimateKonvaTextHeight
                                            }
                                            formatListContent={
                                              formatListContent
                                            }
                                            hasNoteContent={hasNoteContent}
                                            hasTaskContent={hasTaskContent}
                                            calculateGroupHeight={
                                              calculateGroupHeight
                                            }
                                            calculateTextBlockWidth={
                                              calculateTextBlockWidth
                                            }
                                          />
                                        </div>
                                      );
                                    }
                                    case "attachment": {
                                      const attachmentList =
                                        item.attachments || [];
                                      if (attachmentList.length === 0)
                                        return null;

                                      const currentAttachmentNumber =
                                        attachmentCounter++;

                                      const label = (
                                        <h2
                                          style={{
                                            color: "#333",
                                            fontSize: "20px",
                                          }}
                                        >
                                          Attachment {currentAttachmentNumber}
                                        </h2>
                                      );

                                      return (
                                        <div
                                          className="header-spacing"
                                          key={
                                            item.attachment_tree_node_id ||
                                            `attachment-${currentAttachmentNumber}`
                                          }
                                        >
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              style={{
                                                display: "flex",
                                                gap: "6px",
                                                cursor: "pointer",
                                                marginTop: "20px",
                                              }}
                                            >
                                              {label}
                                            </label>

                                            <div
                                              style={{
                                                color: "#888",
                                                fontSize: "14px",
                                                fontWeight: "normal",
                                              }}
                                            >
                                              Section{" "}
                                              {reorderedPreviewSections.findIndex(
                                                (s) =>
                                                  s.section_tree_node_id ===
                                                  section.section_tree_node_id
                                              ) + 1}{" "}
                                              &gt; Step {globalStepNumber} &gt;
                                              Substep {globalStepNumber}
                                              {substepLetter}
                                            </div>
                                          </div>
                                          <div>{item.short_description}</div>
                                          {attachmentList.map(
                                            (attachment, i) => (
                                              <div
                                                key={i}
                                                style={{ marginLeft: "20px" }}
                                              >
                                                {renderPreview(attachment)}
                                              </div>
                                            )
                                          )}
                                        </div>
                                      );
                                    }
                                    default:
                                      return null;
                                  }
                                })}
                              </div>
                            );
                          }
                        )}
                      </div>
                    );
                  })}
                </div>
              );
            })}
        </div>
      </div>

      {/* Snackbar */}
      {snackbar.open && (
        <Snackbar
          message={snackbar.message}
          type={snackbar.type}
          onClose={handleCloseSnackbar}
        />
      )}

      {/* Modal */}
      {isModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content_addsection">
            {/* Header */}
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              <h4
                style={{
                  marginLeft: "23px",
                  fontSize: "18px",
                  color: "#333333",
                }}
              >
                Confirm Copy of {treeNode} from {partNumber}, Rev {revision}
              </h4>
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "10px",
                  background: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                  color: "#666",
                }}
                disabled={isLoading}
              >
                ✕
              </button>
            </div>

            {/* Modal Body */}
            <div
              style={{ padding: "24px", marginTop: "-28px", color: "#333333" }}
            >
              <h4 style={{ fontSize: "14px" }}>
                For {partNumber} &gt; Rev {revision} &gt; {treeNode}
              </h4>

              <p style={{ fontSize: "14px", color: "#333333" }}>
                <strong>Editor:</strong>{" "}
                <span style={{ marginLeft: "10px" }}>
                  {localStorage.getItem("user_name")}
                </span>
              </p>

              <label
                className="modal-label"
                style={{ fontSize: "14px", color: "#333333" }}
              >
                Comment
                <span className="required" style={{ marginLeft: "-1px" }}>
                  *
                </span>
              </label>
              <textarea
                className="modal-textarea"
                placeholder="Enter your comments here..."
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                style={{
                  width: "100%",
                  minHeight: "100px",
                  padding: "8px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                }}
                disabled={isLoading}
              ></textarea>
            </div>

            {/* Footer */}
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
                padding: "16px 24px",
                borderTop: "1px solid #e0e0e0",
                marginTop: "-10px",
                position: "relative",
              }}
            >
              {/* {isLoading && (
                <div
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                    zIndex: 10,
                  }}
                >
                  <div
                    className="loader-spinner"
                    style={{
                      border: "4px solid #f3f3f3",
                      borderRadius: "50%",
                      width: "20px",
                      height: "20px",
                      animation: "spin 1s linear infinite",
                      marginRight: "10px",
                    }}
                  ></div>
                  <span>Processing...</span>
                </div>
              )} */}
              <button
                onClick={() => setModalOpen(false)}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #ccc",
                  borderRadius: "4px",
                  background: "#6c757d",
                  color: "#e9ecef",
                  cursor: isLoading ? "not-allowed" : "pointer",
                }}
                disabled={isLoading}
              >
                Close
              </button>
              <button
                onClick={handleConfirmSave}
                style={{
                  padding: "8px 16px",
                  border: "1px solid #007bff",
                  borderRadius: "4px",
                  background: "#007bff",
                  color: "white",
                  cursor: isLoading ? "not-allowed" : "pointer",
                  opacity: isLoading ? 0.7 : 1,
                }}
                disabled={isLoading}
              >
                {/* {isLoading ? "Processing..." : "Save"} */}
                Save
              </button>
            </div>
          </div>
        </div>
      )}
      <div style={{ height: "100px" }}></div>
    </div>
  );
};

export default ProcedureSectionCopyPreview;
